import React from "react";
import { Field, ErrorMessage } from "formik";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const SimpleCheckbox = ({
  name,
  label,
  disabled = false,
  onChange,
  className = "",
}) => {
  return (
    <div className={`mb-3 ${className}`}>
      <Field name={name}>
        {({ field, form }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                color="primary"
                disabled={disabled}
                onChange={(e) => {
                  field.onChange(e);

                  if (onChange) {
                    onChange(e, form);
                  }
                }}
                className="mr-2"
              />
            }
            label={<span className="mb-0">{label}</span>}
          />
        )}
      </Field>

      <ErrorMessage name={name} component="div" className="text-danger ml-4" />
    </div>
  );
};

export default SimpleCheckbox;
